export const SUPPORTERS_SUCCESS = "SUPPORTERS_SUCCESS";
export const TURF_SUCCESS = "TURF_SUCCESS";